import {useEffect} from "react";
import {atom, selector, useRecoilState} from "recoil";
import {useTranslation} from "react-i18next";

export enum Languages {
  EN = 'en',
  RU = 'ru',
  // TR = 'tr',
  // ZH = 'zh',
  // FR = 'fr',
  // VI = 'vi',
  // HI = 'hi',
  // TH = 'th',
}

export const languageAtom = atom<Languages>({
  key: 'language',
  default: localStorage.getItem('i18nextLng')
    ? localStorage.getItem('i18nextLng') as Languages
    : Languages.EN,
});

export const currentLanguage = selector<Languages>({
  key: 'currentLanguageState',
  get: ({get}) => {
    return get(languageAtom);
  },
  set: ({set}, newValue) => {
    set(languageAtom, newValue);
    localStorage.setItem('i18nextLng', newValue as Languages);
  },
});

export default function LanguageStore() {
  const {i18n} = useTranslation();
  const [language, setLanguage] = useRecoilState(currentLanguage);

  useEffect(() => {
    const resolved = i18n.resolvedLanguage as Languages;
    if (resolved !== language) {
      setLanguage(resolved);
    }
  }, [language, setLanguage, i18n]);

  return (
    <></>
  );
}
